import React, {Fragment, useEffect, useState} from 'react';
import { Link } from "react-router-dom";
import Dropdown from '../../Dropdown';
import Icon from '../../Icon';
import createLink from "../../../../libs/createLink";
import CtaCannot from "../../CtaCannot";
import moment from "moment";
import {useQueryClient} from "@tanstack/react-query";
import {USER_CURRENT_KEY} from "../../../../api/public-voissa/users";
import _ from "lodash";

const FakeNotificationsList = (props) =>{
    return (
        <>
            <div className="notifications-list" onClick={props.handleCloseDropdown}>
                {props.notificationTotal === 0 ? (
                        <div className="no-content">Aucune notification pour le moment</div>
                    ) :
                    props.notifications.map((notification, index) => (
                        <a
                            key={index}
                            href={notification.linkTo}
                            target={"_blank"}
                            className={"notification-item unread"}
                            rel="noopener noreferrer noindex nofollow"
                        >
                            <div className="content">
                                {notification.title}.
                            </div>
                            <div className="sub">
                                <Icon type={notification.icon}/>
                                <span className="date">
                                    {moment(notification.createdAt).fromNow()}
                                </span>
                            </div>
                        </a>
                    ))
                }
            </div>
            <div className="see-more-notifications" onClick={props.handleCloseDropdown}>
                <Link to="/notifications">Voir toutes les notifications</Link>
            </div>
        </>
    )
}

const intervalSteep = [0,5,3,32,20];// interval entre chaque steep

let scenario = JSON.parse(localStorage.getItem(`${process.env.REACT_APP_TOKEN_NAME}_notifications_pub`)) || {
    typeScenario : Math.floor(Math.random() * 1e9) % 2,
    steep : 0,
    createdAt : new Date()
};

if(!scenario.steep){
 scenario = {
     typeScenario : Math.floor(Math.random() * 1e9) % 2,
     steep : 0,
     createdAt : new Date()
 };

}

//on prepare les scenarios et steep
const listScenario = [
    {
        notifications : {
            0 : [],
            1 : [{icon : "notif-voissnap", title : <Fragment>Echange des nudes sur <b>Voissnap</b> [200 jetons offerts]</Fragment>, createdAt : moment(scenario.scenarioCreatedAt).subtract(intervalSteep[1], 'seconds'), linkTo : "https://tracker.voissnap.com/index.php?key=d9nqn65ezv2wvzoh8dhl&t=notif-signup-200tokens&source=notifications_guests&spot=notif_1a"}],
            2 : [{icon : "notif-voissnap", title : <Fragment>Echange des nudes sur <b>Voissnap</b> [200 jetons offerts]</Fragment>, createdAt : moment(scenario.scenarioCreatedAt).subtract(intervalSteep[1], 'seconds'), linkTo : "https://tracker.voissnap.com/index.php?key=d9nqn65ezv2wvzoh8dhl&t=notif-signup-200tokens&source=notifications_guests&spot=notif_1a"}, {icon : "notif-rencontre", title : <Fragment>Nos conseils pour faire des <b>rencontres coquines</b></Fragment>, createdAt : moment(scenario.scenarioCreatedAt).subtract(intervalSteep[2], 'seconds'), linkTo : "https://www.voissa.com/comparateur/rencontres?source=notifications_guests_2a"}],
            3 : [{icon : "notif-voissnap", title : <Fragment>Echange des nudes sur <b>Voissnap</b> [200 jetons offerts]</Fragment>, createdAt : moment(scenario.scenarioCreatedAt).subtract(intervalSteep[1], 'seconds'), linkTo : "https://tracker.voissnap.com/index.php?key=d9nqn65ezv2wvzoh8dhl&t=notif-signup-200tokens&source=notifications_guests&spot=notif_1a"}, {icon : "notif-rencontre", title : <Fragment>Nos conseils pour faire des <b>rencontres coquines</b></Fragment>, createdAt : moment(scenario.scenarioCreatedAt).subtract(intervalSteep[2], 'seconds'), linkTo : "https://www.voissa.com/comparateur/rencontres?source=notifications_guests_2a"}],
            4 : [{icon : "notif-voissnap", title : <Fragment>Echange des nudes sur <b>Voissnap</b> [200 jetons offerts]</Fragment>, createdAt : moment(scenario.scenarioCreatedAt).subtract(intervalSteep[1], 'seconds'), linkTo : "https://tracker.voissnap.com/index.php?key=d9nqn65ezv2wvzoh8dhl&t=notif-signup-200tokens&source=notifications_guests&spot=notif_1a"}, {icon : "notif-rencontre", title : <Fragment>Nos conseils pour faire des <b>rencontres coquines</b></Fragment>, createdAt : moment(scenario.scenarioCreatedAt).subtract(intervalSteep[2], 'seconds'), linkTo : "https://www.voissa.com/comparateur/rencontres?source=notifications_guests_2a"}, {icon : "notif-chat", title : <Fragment>Voir des filles <b>dans ta région</b> qui veulent chatter</Fragment>, createdAt : moment(scenario.scenarioCreatedAt).subtract(intervalSteep[4], 'seconds'), linkTo : "https://tracker.snaping.net/index.php?key=3vpgzn96uz7riniiqdis&t=notif-dating&source=notifications_guests&spot=notif_3a"}]
        },
        messenger : {
            0 : 0,
            1 : 0,
            2 : 0,
            3 : 1,
            4 : 1
        }
    },
    {
        notifications : {
            0 : [],
            1 : [{icon : "notif-voissnap", title : <Fragment>Plans cul avec des filles chaudes sur <b>Voissnap</b></Fragment>, createdAt : moment(scenario.scenarioCreatedAt).subtract(intervalSteep[1], 'seconds'), linkTo : "https://tracker.voissnap.com/index.php?key=d9nqn65ezv2wvzoh8dhl&t=notif-dating&source=notifications_guests&spot=notif_1b"}],
            2 : [{icon : "notif-voissnap", title : <Fragment>Plans cul avec des filles chaudes sur <b>Voissnap</b></Fragment>, createdAt : moment(scenario.scenarioCreatedAt).subtract(intervalSteep[1], 'seconds'), linkTo : "https://tracker.voissnap.com/index.php?key=d9nqn65ezv2wvzoh8dhl&t=notif-dating&source=notifications_guests&spot=notif_1b"}, {icon : "notif-rencontre", title : <Fragment>Les <b>meilleurs sites de plans cul</b> par Voissa</Fragment>, createdAt : moment(scenario.scenarioCreatedAt).subtract(intervalSteep[2], 'seconds'), linkTo : "https://www.voissa.com/comparateur/rencontres?source=notifications_guests_2b"}],
            3 : [{icon : "notif-voissnap", title : <Fragment>Plans cul avec des filles chaudes sur <b>Voissnap</b></Fragment>, createdAt : moment(scenario.scenarioCreatedAt).subtract(intervalSteep[1], 'seconds'), linkTo : "https://tracker.voissnap.com/index.php?key=d9nqn65ezv2wvzoh8dhl&t=notif-dating&source=notifications_guests&spot=notif_1b"}, {icon : "notif-rencontre", title : <Fragment>Les <b>meilleurs sites de plans cul</b> par Voissa</Fragment>, createdAt : moment(scenario.scenarioCreatedAt).subtract(intervalSteep[2], 'seconds'), linkTo : "https://www.voissa.com/comparateur/rencontres?source=notifications_guests_2b"}],
            4 : [{icon : "notif-voissnap", title : <Fragment>Plans cul avec des filles chaudes sur <b>Voissnap</b></Fragment>, createdAt : moment(scenario.scenarioCreatedAt).subtract(intervalSteep[1], 'seconds'), linkTo : "https://tracker.voissnap.com/index.php?key=d9nqn65ezv2wvzoh8dhl&t=notif-dating&source=notifications_guests&spot=notif_1b"}, {icon : "notif-rencontre", title : <Fragment>Les <b>meilleurs sites de plans cul</b> par Voissa</Fragment>, createdAt : moment(scenario.scenarioCreatedAt).subtract(intervalSteep[2], 'seconds'), linkTo : "https://www.voissa.com/comparateur/rencontres?source=notifications_guests_2b"}, {icon : "notif-chat", title : <Fragment>Trouve un plan cul <b>pour ce soir</b></Fragment>, createdAt : moment(scenario.scenarioCreatedAt).subtract(intervalSteep[4], 'seconds'), linkTo : "https://tracker.snaping.net/index.php?key=3vpgzn96uz7riniiqdis&t=notif-dating&source=notifications_guests&spot=notif_3c"}]
        },
        messenger : {
            0 : 0,
            1 : 0,
            2 : 0,
            3 : 1,
            4 : 1
        }
    }
];

const FakeNotifications = ({
       handleCloseDropdown = () =>{},
       toggleNotif = () =>{},
       handleToggleNotification = () =>{}
   }) =>{

    const queryClient = useQueryClient();

    const dataCurrentUser = queryClient.getQueryData([USER_CURRENT_KEY]);
    const isCurrentUser = !!_.get(dataCurrentUser, '_id');

    let source = localStorage.getItem(`${process.env.REACT_APP_TOKEN_NAME}_source`) || "voissa";


    const [currentScenario, setCurrentScenario] = useState(scenario);


    useEffect(() => {
        let timeoutScenario = null;
        function generateScenario(){
            let currentSteep = currentScenario.steep;
            let nextSteep = currentSteep + 1;
            let maxSteep = intervalSteep.length -1;

            if(nextSteep <= maxSteep) {
                timeoutScenario = setTimeout(() => {
                    localStorage.setItem(`${process.env.REACT_APP_TOKEN_NAME}_notifications_pub`, JSON.stringify({...currentScenario, steep :  nextSteep }));
                    if(nextSteep <= maxSteep) {
                        setCurrentScenario({...currentScenario, steep : nextSteep});
                    }
                }, (intervalSteep[nextSteep] * 1000));
            }
            else{
                clearTimeout(timeoutScenario);
            }
        }
        const handleData = () => {
            generateScenario();
        }
        handleData();
        return () => {
            clearTimeout(timeoutScenario);
        };
    }, [currentScenario]);

    let notifications = listScenario[currentScenario.typeScenario]['notifications'][currentScenario.steep] || [];
    let notificationsTotal = notifications.length;
    let messengerTotal = listScenario[currentScenario.typeScenario]['messenger'][currentScenario.steep] || 0;


    return (
        !isCurrentUser && source !=="nouslib" ? (
            <>
                <CtaCannot
                    action={"chatWebcam"}
                    isModal={true}
                >
                    <div className={"access-messenger cursor-pointer"}> <Icon type={"chat-webcam"} className={"icon-chat"} /></div>
                </CtaCannot>

                <Link className={"access-messenger"} to={createLink("signup")}>
                    <Icon type={"speech-bubbles"}/>
                    {messengerTotal > 0 && <div className={`notifications-count notification_appearing`}>{messengerTotal > 99 ? '99+' : messengerTotal}</div>}
                </Link>

                <Dropdown className="notification-dropdown" align="right"
                          handleToggleChildren={handleToggleNotification}
                          toggleStatus={toggleNotif}
                          activableComponent={(
                              <div className="notifications">
                                  <Icon type="bell"/>
                                  {notificationsTotal > 0 && <div
                                      className={`notifications-count notification_appearing`}>{notificationsTotal > 99 ? '99+' : notificationsTotal}</div>}
                              </div>
                          )}>
                    <div className="topline-notification-dropdown">
                        <div className="title">Notifications</div>
                        <div className="options-dropdown">
                            <div className="read-all">Tout marquer comme lu</div>
                            -
                            <Link to={createLink("userMeSettingsOptionsNotifications")}>
                                <div className="settings" onClick={() => handleCloseDropdown()} >Paramètres</div>
                            </Link>
                        </div>
                    </div>
                    <FakeNotificationsList
                        handleCloseDropdown={()=>handleCloseDropdown}
                        notificationTotal={notificationsTotal}
                        notifications={notifications}
                    />
                </Dropdown>
            </>
        ) : null
    )
};
export default FakeNotifications;